module.exports = __webpack_public_path__ + "static/media/login.7ff3754b.png";